import {
  getMaxPastedContentLength,
  getMaxTopicLength,
} from "./envLimits";

/** Keep aligned with backend TEMA_VALIDATION_* defaults (resolved from env at build/runtime). */
export const MAX_PASTED_CONTENT_LENGTH = getMaxPastedContentLength();
export const MAX_TOPIC_LENGTH = getMaxTopicLength();
export const MAX_REGENERATION_INSTRUCTIONS_LENGTH = 2_000;
export const MAX_LEARNING_OBJECTIVES_LENGTH = 2_000;

export {
  getMaxPastedContentLength,
  getMaxTopicLength,
  getUploadMaxFileBytes,
} from "./envLimits";
